import { Component, Inject, Input, OnInit } from "@angular/core";
import { AnalyticsService } from "@gtmhub/core/analytics";
import { actionHandlerGenerator } from "@gtmhub/shared/utils";
import { StateService } from "@uirouter/core";
import { WINDOW } from "@webapp/core/util/factories/window.factory";
import { DropdownMenuItem, IDropdownMenuItemIcon, IDropdownMenuItemToggle } from "@webapp/shared/gh-dropdown/gh-dropdown.models";

/**
 * @example <li *ngFor="let item of this.menuItems" gh-dropdown-menu-item [item]="item"></li>
 * @param item IDropdownMenuItem
 */
@Component({
  selector: "[gh-dropdown-menu-item]",
  templateUrl: "./gh-dropdown-menu-item.component.html",
})
export class GhDropdownMenuItemComponent implements OnInit {
  @Input()
  item: DropdownMenuItem;
  actionHandler: () => unknown;

  constructor(private $state: StateService, @Inject(WINDOW) private $window: Window, private analyticsService: AnalyticsService) {}

  ngOnInit(): void {
    if (this.item.action && !this.item.disabled) {
      this.actionHandler = actionHandlerGenerator(this.item.action, { $state: this.$state, $window: this.$window });
    }
  }

  getIconClass(): string {
    return "gh-font-icon-" + (this.item as IDropdownMenuItemIcon).icon;
  }

  getToggleValue(): boolean {
    return (this.item as IDropdownMenuItemToggle).value === undefined ? false : (this.item as IDropdownMenuItemToggle).value;
  }

  getItemTrackMetaDataAsString(): string {
    return this.item.trackMetaData ? JSON.stringify(this.item.trackMetaData) : "";
  }

  invokeAction(): void {
    if (this.item.track) {
      this.analyticsService.track(this.item.track, this.item.trackMetaData);
    }
    this.actionHandler();
  }
}
